<template>
  <div class="content">
    <el-button type="primary" class="btn-add" @click="comedit('row','new')" style="margin-bottom:28px">新增员工</el-button>

    <el-table
      :data="tableData"
      border
      :header-cell-style="{ background: '#f6f9ff',color:'#7c8db5'}" :cell-style="{color:'#25396f'}"
    >
      <!--      <el-table-column-->
      <!--        label="ID"-->
      <!--        prop="id"-->
      <!--        align="center"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <el-table-column
        label="员工姓名"
        prop="person"
        align="center"
      >
      </el-table-column>
      <el-table-column label="岗位" prop="person_post" align="center">
      </el-table-column>
      <el-table-column label="所属部门" prop="department_name" align="center">
      </el-table-column>
      <el-table-column label="入职时间" prop="entry_time" align="center">
      </el-table-column>
      <el-table-column label="在职状态" prop="is_active" align="center">
        <template slot-scope="scope">
          {{ scope.row.is_active == 1 ? '在职' : '离职' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <span class="caozuo" @click="comedit(scope.$index, scope.row)"
                style="color:#347ae2;cursor: pointer;">修改</span>
          <span class="caozuo" @click="delColomn(scope.row.id)" style="color:#ec4b4b;cursor: pointer;">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-if="total > 0"
      :currentPage="currentPage"
      :total="total"
      :limit="limit"
      @handleCurrentChange="handleCurrentChange">
    </Pagination>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      class="diago"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="auto" :rules="rules">
        <el-form-item label="员工姓名：" prop="name">
          <el-input style="width:300px" v-model="form.name" placeholder="请输入员工姓名"></el-input>
        </el-form-item>

        <el-form-item label="岗位：" prop="person_post">
          <el-input style="width:300px" v-model="form.person_post" placeholder="请输入岗位名称"></el-input>
        </el-form-item>
        <el-form-item label="所属部门：" prop="comp">
          <el-select v-model="form.comp" placeholder="请选择部门" style="width:300px">
            <el-option
              v-for="item in depData"
              :key="item.id"
              :label="item.department_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间：" prop="person_post">
          <el-date-picker
            v-model="form.entry_time"
            type="date"
            style="width:300px"
            value-format="yyyy-MM-dd"
            placeholder="请选择入职时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="在职状态：">
          <el-switch
            style="display: block"
            :active-value="1"
            :inactive-value="0"
            v-model="form.is_active"
            active-color="#13ce66"
            inactive-color="#dcdfe6"
            active-text="在职"
            inactive-text="离职">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" class="btn-cancel">取 消</el-button>
            <el-button type="primary" @click="uodata" class="btn-submit1">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import {get_department, create_department, mod_department, del_department, get_departments} from "../../api/user";

export default {
  data() {
    return {
      title: '',
      dialogVisible: false,
      id: '',
      tableData: [],
      currentPage: 1,
      total: 0,
      limit: 100,
      form: {
        id: '',
        name: '',
        comp: '',
        is_active:1,
        entry_time:'',
        person_post:''
      },
      pw: '',
      rules: {
        name: [
          {required: true, message: '请输入员工名称', trigger: 'change'}
        ],
        comp: [
          {required: true, message: '请选择部门', trigger: 'change'}
        ],
        entry_time: [
          {required: true, message: '请选择入职时间', trigger: 'change'}
        ],
        person_post: [
          {required: true, message: '请输入岗位名称', trigger: 'change'}
        ],
      },
      actic: 'actic',
      depData: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData()
    },
    //删除单个
    delColomn(id) {
      this.$confirm('确定删除该员工吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            personid: id
          }
          del_department(params).then(res => {
            if (res.code == 200) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // change(id, is_admin) {
    //   let params = {
    //     token: localStorage.getItem("token"),
    //     id: id,
    //     is_admin: is_admin
    //   }
    //   updateusers(params).then(res => {
    //     if (res.errno === 0) {
    //       this.$message({
    //         type: "success",
    //         message: res.data
    //       });
    //     } else {
    //       // this.$message.error(res.data);
    //     }
    //   })
    // },

    //修改用户
    comedit(index, row) {
      if (row != 'new') {
        this.title = '修改'
        this.form.id = row.id
        this.form.name = row.person
        this.form.comp = row.departments_id
        this.form.entry_time = row.entry_time
        this.form.is_active = row.is_active
        this.form.person_post = row.person_post
        this.dialogVisible = true
      } else {
        this.title = '新增'
        this.form.id = ''
        this.form.name = ''
        this.form.comp = ''
        this.form.entry_time = ''
        this.form.is_active = 1
        this.form.person_post = ''
        this.dialogVisible = true
      }
    },
    //获取部门
    async getDept() {
      let params = {
        token: localStorage.getItem("token"),
        // page: this.currentPage,
        // limit:10
      }
      await get_departments(params).then(res => {
        if (res.code === 200) {
          this.depData = res.data;
          // this.limit = res.limit;
          // this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async getData() {
      let params = {
        token: localStorage.getItem("token"),
        page: this.currentPage,
        limit: 100
      }
      await get_department(params).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          for (let i = 0; i < this.tableData.length; i++) {
            for (let j = 0; j < this.depData.length; j++) {
              if (this.tableData[i].departments_id == this.depData[j].id) {
                // this.tableData[i].departments_id = this.depData[j].id
                this.tableData[i].department_name = this.depData[j].department_name
              }
            }
          }
          // console.log(this.tableData)
          // this.limit = res.limit;
          this.total = res.total;
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async getAllData() {
      try {
        await this.getDept()
        await this.getData()
      } catch (e) {
      }
    },

    uodata() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          // if (this.form.name == '' || this.form.comp == '') {
          //   this.$message.warning('请完善信息后再提交！')
          //   return
          // }
          if (this.title == '修改') {
            let params = {
              personid: this.form.id,
              departments_id: this.form.comp,
              person: this.form.name,
              person_post: this.form.person_post,
              entry_time: this.form.entry_time,
              is_active: this.form.is_active,
            }
            mod_department(params).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('修改成功')
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            let params = {
              departments_id: this.form.comp,
              person: this.form.name,
              person_post: this.form.person_post,
              entry_time: this.form.entry_time,
              is_active: this.form.is_active,
            }
            create_department(params).then(res => {
              if (res.code === 200) {
                this.dialogVisible = false
                this.$message.success('添加成功')
                this.getData()
              } else {
                this.$message.error(res.msg)
              }
            })
          }


        } else {
          return false;
        }
      });
      //
      //
      // }
    },
  },
  mounted() {
    this.getAllData()
    // this.getData()
  }
}
</script>

<style scoped>
.content >>> .el-switch__label {
  line-height: 20px;
}

.content >>> .el-switch {
  height: 40px;
  line-height: 40px;
  width: 200px;
}

.content >>> .el-dialog__footer {
  text-align: center;
}

.actic {
  color: red;
}

.content >>> .el-dialog {
  width: 30%;
}

.content >>> .el-dialog__title {
  color: #25396f;
  font-size: 16px;
}

.content >>> .el-dialog__body {
  font-size: 12px;
  color: #25396f;
}

.diago >>> .el-dialog {
  min-width: 430px;
}
</style>





// WEBPACK FOOTER //
// src/views/user/user.vue